// SPDX-License-Identifier: AGPL-3.0-or-later
// Popular Fusion local overlay — safe to delete after the season.

import {millisecondsUntilNextLocalMidnight} from '@app/features/theme/utils/HolidayClassUtils';
import {
	HALLOWEEN_DM_ICON_SEASON_CLASS,
	isHalloweenDmIconSeasonActive,
} from '@app/local/seasonal/isHalloweenDmIconSeasonActive';
import {useEffect} from 'react';

import '@app/local/seasonal/HalloweenDmIconSeason.module.css';

function applyHalloweenDmIconSeasonClass(root: HTMLElement, active: boolean): void {
	root.classList.toggle(HALLOWEEN_DM_ICON_SEASON_CLASS, active);
}

export function useHalloweenDmIconSeasonClass(): void {
	useEffect(() => {
		if (typeof document === 'undefined') return;
		const root = document.documentElement;
		let timer: ReturnType<typeof setTimeout> | null = null;
		let cancelled = false;
		const tick = () => {
			if (cancelled) return;
			const now = new Date();
			applyHalloweenDmIconSeasonClass(root, isHalloweenDmIconSeasonActive(now));
			timer = setTimeout(tick, millisecondsUntilNextLocalMidnight(now));
		};
		tick();
		return () => {
			cancelled = true;
			if (timer != null) clearTimeout(timer);
			applyHalloweenDmIconSeasonClass(root, false);
		};
	}, []);
}
